import React, { useEffect, useState } from "react";
import {
  Box,
  Button,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import Tabela from "../../components/Tabela";
import {
  buscaFerramenta,
  todaEmpresa,
  todaFerramenta,
} from "../../types/ferramenta";
import {
  deleteFerramenta,
  getFerramentaById,
  getFerramentas,
} from "../../api/ferramentasApi";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

const Ferramenta: React.FC = () => {
  const [ferramenta, setFerramenta] = useState<buscaFerramenta[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [ferramentaSelecionada, setFerramentaSelecionada] =
    useState<todaFerramenta | null>(null);
  const [modalAberta, setModalAberta] = useState<boolean>(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchFerramentas = async () => {
      try {
        const token = localStorage.getItem("token");
        if (!token) {
          throw new Error("Token não encontrado");
        }
        const ferramentaData = await getFerramentas(token);
        setFerramenta(ferramentaData);
      } catch (error) {
        toast.error("Erro ao buscar ferramenta!");
        console.error("Erro ao buscar ferramenta:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchFerramentas();
  }, []);

  const handleAddFerramenta = () => {
    navigate("/adicionarFerramenta");
  };

  const handleEditFerramenta = (id: string) => {
    navigate(`/editarFerramenta/${id}`);
  };

  const handleDeleteFerramenta = async (id: string) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }
      await deleteFerramenta(token, id);
      setFerramenta(
        ferramenta.filter((ferramenta) => ferramenta.id !== Number(id))
      );
      toast.success("Ferramenta excluída com sucesso!");
    } catch (error) {
      toast.error("Erro ao excluir ferramenta!");
      console.error("Erro ao excluir ferramenta:", error);
    }
  };

  const handleViewFerramenta = async (id: string) => {
    try {
      const token = localStorage.getItem("token");
      if (!token) {
        throw new Error("Token não encontrado");
      }
      const ferramentaData = await getFerramentaById(token, id);
      setFerramentaSelecionada(ferramentaData);
      setModalAberta(true);
    } catch (error) {
      toast.error("Erro ao carregar detalhes da ferramenta!");
      console.error("Erro ao carregar detalhes da ferramenta:", error);
      throw error;
    }
  };

  const handleFecharModal = () => {
    setModalAberta(false);
  };

  const colunas = [
    { id: "id", label: "ID" },
    { id: "nome_ferramenta", label: "Nome da Ferramenta" },
    { id: "nome_token_ferramenta", label: "Nome Token da Ferramenta" },
    { id: "habilidade_ferramenta", label: "Habilidade da Ferramenta" },
  ];

  return (
    <Box sx={{ p: 3 }}>
      <Tabela
        titulo="Ferramenta"
        colunas={colunas}
        dados={ferramenta}
        onAdd={handleAddFerramenta}
        onEdit={handleEditFerramenta}
        onDelete={handleDeleteFerramenta}
        onView={handleViewFerramenta}
        showVisibilityIcon={true}
        loading={loading}
      />
      <Modal open={modalAberta} onClose={handleFecharModal}>
        <Box
          sx={{
            position: "absolute",
            top: "50%",
            left: "50%",
            transform: "translate(-50%, -50%)",
            bgcolor: "background.paper",
            boxShadow: 24,
            p: 4,
            minWidth: "50%",
          }}
        >
          {ferramentaSelecionada ? (
            <>
              <Typography variant="h6">Empresas Cadastradas:</Typography>
              {ferramentaSelecionada.empresas.length > 0 ? (
                <TableContainer component={Box} sx={{ maxHeight: 400 }}>
                  <Table stickyHeader>
                    <TableHead>
                      <TableRow>
                        <TableCell>ID</TableCell>
                        <TableCell>CNPJ</TableCell>
                        <TableCell>Nome</TableCell>

                        <TableCell>Ativo</TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {ferramentaSelecionada.empresas.map(
                        (empresa: todaEmpresa) => (
                          <TableRow key={empresa.id}>
                            <TableCell>{empresa.id}</TableCell>
                            <TableCell>{empresa.cnpj_empresa}</TableCell>
                            <TableCell>{empresa.nome_empresa}</TableCell>
                            <TableCell>
                              {empresa.pivot.ativo_empresa_ferramenta}
                            </TableCell>
                          </TableRow>
                        )
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
              ) : (
                <Typography variant="body1" mt={2}>
                  Nenhuma empresa encontrada.
                </Typography>
              )}
              <Box sx={{ display: "flex", justifyContent: "flex-end", mt: 2 }}>
                <Button
                  type="submit"
                  variant="contained"
                  color="primary"
                  onClick={handleFecharModal}
                >
                  Fechar
                </Button>
              </Box>
            </>
          ) : (
            <Typography variant="body1">
              Nenhuma informação disponível.
            </Typography>
          )}
        </Box>
      </Modal>
    </Box>
  );
};

export default Ferramenta;
